import { api } from "../../lib/api";

// ---- public
export const getPublicQuestions = async () => (await api.get("/riskprofiler/questions")).data;
export const submitProfiler = async (body) => (await api.post("/riskprofiler/submit", body)).data;

// ---- admin: submissions / analytics / export / pdf
export const adminListSubmissions = async (params = {}) =>
    (await api.get("/riskprofiler/admin/submissions", { params })).data;
export const adminGetSubmission = async (id) =>
    (await api.get(`/riskprofiler/admin/submissions/${id}`)).data;
export const recalculateProfiles = async () => (await api.post("/riskprofiler/admin/recalculate")).data;

const saveBlob = (data, filename, type) => {
    const url = window.URL.createObjectURL(new Blob([data], { type }));
    const a = document.createElement("a");
    a.href = url; a.download = filename; document.body.appendChild(a); a.click();
    a.remove(); window.URL.revokeObjectURL(url);
};

export const openSubmissionPdf = async (id, name, download = false) => {
    const res = await api.get(`/riskprofiler/admin/submissions/${id}/pdf`, {
        params: download ? { download: 1 } : {}, responseType: "blob",
    });
    const safe = (name || "client").replace(/\s+/g, "-");
    if (download) { saveBlob(res.data, `risk-profile-${safe}.pdf`, "application/pdf"); return; }
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    window.open(url, "_blank");
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const exportSubmissions = async (params = {}, detailed = false) => {
    const res = await api.get("/riskprofiler/admin/export", {
        params: { ...params, detailed: detailed ? 1 : 0 }, responseType: "blob",
    });
    saveBlob(res.data, detailed ? "risk-profiler-detailed.csv" : "risk-profiler-results.csv", "text/csv");
};

// ---- admin: questions
export const adminListQuestions = async () => (await api.get("/riskprofiler/admin/questions")).data;
export const createQuestion = async (body) => (await api.post("/riskprofiler/admin/questions", body)).data;
export const updateQuestion = async (id, body) => (await api.put(`/riskprofiler/admin/questions/${id}`, body)).data;
export const toggleQuestion = async (id, active) => (await api.patch(`/riskprofiler/admin/questions/${id}/active`, { active })).data;
export const deleteQuestion = async (id) => (await api.delete(`/riskprofiler/admin/questions/${id}`)).data;
export const reorderQuestions = async (ordered_ids) => (await api.post("/riskprofiler/admin/questions/reorder", { ordered_ids })).data;

// ---- admin: config
export const adminGetConfig = async () => (await api.get("/riskprofiler/admin/config")).data;
export const adminSaveConfig = async (body) => (await api.put("/riskprofiler/admin/config", body)).data;

// ---- admin: import
export const importPreview = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return (await api.post("/riskprofiler/admin/import/preview", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const importCommit = async (rows) => (await api.post("/riskprofiler/admin/import/commit", { rows })).data;
export const downloadSampleCsv = async () => {
    const res = await api.get("/riskprofiler/admin/import/sample", { responseType: "blob" });
    saveBlob(res.data, "risk-profiler-sample.csv", "text/csv");
};
